import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { ICampaignTemplate } from 'queries/fetch/fetchCampaignTemplatesForTeam.ts';

interface ICreateCampaignTemplateAPIResponse {
    templateId: string,
}

export default function useUpdateCampaignTemplate() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      teamId,
      templateID,
      template,
    }: { teamId: string; templateID: string; template: ICampaignTemplate; }) => apiFetch<ICreateCampaignTemplateAPIResponse>({
      path: `team/${teamId}/template/${templateID}`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: template,
    }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['teamCampaignTemplates', { teamId: variables.teamId }],
      });
    },
  });
}
